import { ActionContext } from 'vuex'
import { api } from '@/api'
import { OrderConfigsEnumsResponse, EnumsType } from 'supporter'

export interface ValueNameType {
  value: string
  name: string
}

export default {
  namespaced: true,
  state: {
    payType: [],
    pgType: [],
  },
  getters: {
    payType(state: OrderConfigsEnumsResponse): EnumsType[] {
      return [...state.payType]
    },
    pgType(state: OrderConfigsEnumsResponse): EnumsType[] {
      return [...state.pgType]
    },
    payTypeMap(state: OrderConfigsEnumsResponse): ValueNameType[] {
      return state.payType.map(({ name, label }) => ({
        value: name,
        name: label,
      }))
    },
    pgTypeMap(state: OrderConfigsEnumsResponse): ValueNameType[] {
      return state.pgType.map(({ name, label }) => ({
        value: name,
        name: label,
      }))
    },
  },
  mutations: {
    SET_PAY_TYPE(state: OrderConfigsEnumsResponse, payType: EnumsType[]): void {
      state.payType = payType
    },
    SET_PG_TYPE(state: OrderConfigsEnumsResponse, pgType: EnumsType[]): void {
      state.pgType = pgType
    },
  },
  actions: {
    async fetchOrderConfigsEnums({
      commit,
    }: ActionContext<
      OrderConfigsEnumsResponse,
      OrderConfigsEnumsResponse
    >): Promise<void> {
      const { data } = await api.getOrderConfigsEnums()

      commit('SET_PAY_TYPE', data.payType)
      commit('SET_PG_TYPE', data.pgType)
    },
  },
}
